'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _iterator2 = require('babel-runtime/core-js/symbol/iterator');

var _iterator3 = _interopRequireDefault(_iterator2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _helpers = require('helpers');

var _auth = require('redux/actions/auth');

var _user = require('redux/actions/user');

var _modal_type = require('redux/actions/modal_type');

var _reduxAsyncConnect = require('redux-async-connect');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Profile: {
        displayName: 'Profile'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Personal/Profile/Profile.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var Profile = _wrapComponent('Profile')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
    promise: function promise(_ref) {
        var _ref$store = _ref.store,
            dispatch = _ref$store.dispatch,
            getState = _ref$store.getState;

        return dispatch((0, _extends4.default)({}, (0, _auth.load)()));
    }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
    return {
        lang: state.lang,
        setting: state.setting,
        user: state.auth.user,
        error: state.user.error,
        currency: state.currency
    };
}, {
    pushState: _reactRouterRedux.push,
    changeInn: _user.changeInn,
    changeMail: _user.changeMail,
    changeName: _user.changeName,
    changePhone: _user.changePhone,
    changeUlName: _user.changeUlName,
    confirmMail: _user.confirmMail,
    confirmPhone: _user.confirmPhone,
    showModalChangePassword: _modal_type.showModalChangePassword,
    showModalConfirmMail: _modal_type.showModalConfirmMail,
    showModalConfirmOldMail: _modal_type.showModalConfirmOldMail,
    showModalConfirmPhone: _modal_type.showModalConfirmPhone,
    load: _auth.load,
    showModalConfirmChangePhone: _modal_type.showModalConfirmChangePhone
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(Profile, _Component);

    function Profile(props, context) {
        (0, _classCallCheck3.default)(this, Profile);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Profile.__proto__ || (0, _getPrototypeOf2.default)(Profile)).call(this, props, context));

        _this.activeField = function (name) {
            _this.setState(function (prevState) {
                var state = {};

                if (name) {
                    state['disabled_' + name] = !prevState['disabled_' + name];
                }

                return (0, _extends4.default)({}, prevState, state);
            });
        };

        _this.changeField = function (_ref2) {
            var name = _ref2.name,
                value = _ref2.value;

            _this.setState(function (prevState) {
                var _extends2;

                var validate = {};

                if (_this.state.validate.hasOwnProperty(name)) {
                    validate[name] = undefined;
                }

                return (0, _extends4.default)({}, prevState, (_extends2 = {}, (0, _defineProperty3.default)(_extends2, name, value), (0, _defineProperty3.default)(_extends2, 'validate', (0, _extends4.default)({}, prevState.validate, validate)), _extends2));
            });
        };

        _this.resetField = function (name) {
            var user = _this.props.user;
            var confirmed = user.confirmed;


            _this.setState(function (prevState) {
                var state = {};
                var validate = {};

                switch (name) {
                    case 'name':
                        {
                            state[name] = user.name;
                            break;
                        }

                    case 'phone':
                        {
                            state[name] = user.phone;
                            break;
                        }

                    case 'email':
                        {
                            state[name] = user.email;
                            break;
                        }

                    default:
                        {
                            if (name) {
                                state[name] = confirmed[name] || '';
                            }
                            break;
                        }
                }

                if (name) {
                    state['disabled_' + name] = !prevState['disabled_' + name];
                    validate[name] = undefined;
                }

                return (0, _extends4.default)({}, prevState, state, {
                    validate: (0, _extends4.default)({}, prevState.validate, validate)
                });
            });
        };

        _this.changeName = function (pipoId, name, newName) {
            _this.props.changeName(pipoId, name, newName);
            _this.activeField('name');
        };

        _this.changeMail = function (pipoId, newEmail, code) {
            if (newEmail !== _this.props.user.email && newEmail !== '') {
                _this.props.changeMail(pipoId, newEmail, code, function (message) {
                    _this.props.showModalConfirmMail(pipoId, newEmail, message, _this.props.lang);
                });
            } else {
                _this.setState({
                    disabledMail: !_this.state.disabledMail,
                    inputValueMail: _this.props.user.email
                });
                return;
            }

            _this.activeField('email');
        };

        _this.changePhone = function (pipoId, newPhone, code) {
            var lang = _this.props.lang;


            if (newPhone !== _this.props.user.phone && newPhone !== '') {
                _this.props.changePhone(pipoId, newPhone, code, function () {
                    _this.props.showModalConfirmChangePhone(pipoId, newPhone, lang['store.profile.phone_change_confirmation'], lang['store.profile.phone_change_success']);
                }, function () {
                    _this.setState({
                        disabledPhone: !_this.state.disabledPhone,
                        inputValuePhone: _this.props.user.phone
                    });
                });
            } else {
                _this.setState({
                    disabledPhone: !_this.state.disabledPhone,
                    inputValuePhone: _this.props.user.phone
                });
                return;
            }

            _this.activeField('phone');
        };

        _this.acceptValue = function (name) {
            var _this$props = _this.props,
                changeInn = _this$props.changeInn,
                changeUlName = _this$props.changeUlName,
                user = _this$props.user,
                lang = _this$props.lang;


            switch (name) {
                case 'name':
                    {
                        _this.changeName(user.pipo_id, user.name, _this.state.name);
                        break;
                    }

                case 'phone':
                    {
                        _this.changePhone(user.pipo_id, _this.state.phone);
                        break;
                    }

                case 'email':
                    {
                        _this.changeMail(user.pipo_id, _this.state.email);
                        break;
                    }

                case 'ul_name':
                    {
                        changeUlName(_this.state.ul_name);

                        _this.activeField('ul_name');
                        break;
                    }

                case 'inn':
                    {
                        var REGEX_INN = /^[\d]+$/igm;
                        var innErrorMessage = lang['store.profile.wrong_identifier_format'];

                        if (_this.state.inn && REGEX_INN.test(_this.state.inn)) {
                            if (_this.state.inn.length === 10 || _this.state.inn.length === 12) {
                                changeInn(_this.state.inn);

                                _this.activeField('inn');
                            } else {
                                _this.setState({
                                    validate: {
                                        inn: innErrorMessage
                                    }
                                });
                            }
                        } else {
                            _this.setState({
                                validate: {
                                    inn: innErrorMessage
                                }
                            });
                        }
                        break;
                    }

                default:
                    {
                        _this.activeField(name);
                        break;
                    }
            }
        };

        _this.confirmMail = function () {
            var _this$props2 = _this.props,
                confirmMail = _this$props2.confirmMail,
                showModalConfirmOldMail = _this$props2.showModalConfirmOldMail,
                user = _this$props2.user,
                lang = _this$props2.lang;


            confirmMail(user.pipo_id, user.email);
            showModalConfirmOldMail(lang);
        };

        _this.confirmPhone = function () {
            var _this$props3 = _this.props,
                confirmPhone = _this$props3.confirmPhone,
                showModalConfirmPhone = _this$props3.showModalConfirmPhone,
                user = _this$props3.user,
                lang = _this$props3.lang;


            confirmPhone(user.pipo_id, user.phone);
            showModalConfirmPhone(user.pipo_id, user.phone, lang['store.profile.phone_verification'], lang['store.profile.phone_verification_success']);
        };

        _this.changePassword = function (e) {
            e.preventDefault();
            _this.props.showModalChangePassword(_this.props.lang);
        };

        _this.state = {
            email: _this.props.user ? _this.props.user.email : '',
            name: _this.props.user ? _this.props.user.name : '',
            phone: _this.props.user ? _this.props.user.phone : '',
            validate: {}
        };

        return _this;
    }

    (0, _createClass3.default)(Profile, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var user = this.props.user;
            var confirmed = user.confirmed;

            var temp = (0, _extends4.default)({}, confirmed);

            // свойство телефон уже есть
            delete temp.confirmed_phone;

            // динамически затолкаем в состояние значение других свойств
            _Object$keys = (0, _keys2.default)(temp);

            if (!(_Object$keys && (typeof _Object$keys[_iterator3.default] === 'function' || Array.isArray(_Object$keys)))) {
                throw new TypeError('Expected _Object$keys to be iterable, got ' + _inspect(_Object$keys));
            }

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(_Object$keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _Object$keys;

                    var prop = _step.value;

                    this.changeField({
                        name: prop,
                        value: temp[prop]
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }

        /**
         * Активация поля для редактирования
         * @param name
         */


        /**
         * Обработчик изменения текста
         * @param name
         * @param value
         */


        /**
         * Обработчик сброса значения
         * @param name
         */


        /**
         * Обработчик смены email'а
         * @param pipoId
         * @param newEmail
         * @param code
         */


        /**
         * Обработчик смены телефона
         * @param pipoId
         * @param newPhone
         * @param code
         */


        /**
         * Обработчик смены значения у поля
         * @param name
         */


        /**
         * Обработчик подтверждения email
         */


        /**
         * Обработчик подтверждения телефона
         */


        /**
         * Обработчик смены пароля
         * @param e
         */

    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                lang = _props.lang,
                setting = _props.setting,
                user = _props.user,
                currency = _props.currency;


            var View = _helpers.ThemeHelper.getViewForContainer('Profile', null, { folderName: 'Personal/Profile' });

            if (user) {
                return _react3.default.createElement(
                    'div',
                    null,
                    _react3.default.createElement(_reactHelmet2.default, { title: '\u041F\u0440\u043E\u0444\u0438\u043B\u044C' }),
                    _react3.default.createElement(View, {
                        acceptValue: this.acceptValue,
                        activeField: this.activeField,
                        changeField: this.changeField,
                        changePassword: this.changePassword,
                        confirmMail: this.confirmMail,
                        confirmPhone: this.confirmPhone,
                        lang: lang,
                        profile: this.state,
                        resetField: this.resetField,
                        setting: setting,
                        user: user,
                        currency: currency
                    })
                );
            }

            return null;
        }
    }]);
    return Profile;
}(_react2.Component), _class2.propTypes = {
    changeInn: _react2.PropTypes.func.isRequired,
    changeMail: _react2.PropTypes.func.isRequired,
    changeName: _react2.PropTypes.func.isRequired,
    changePhone: _react2.PropTypes.func.isRequired,
    changeUlName: _react2.PropTypes.func.isRequired,
    confirmMail: _react2.PropTypes.func.isRequired,
    confirmPhone: _react2.PropTypes.func.isRequired,
    lang: _react2.PropTypes.object.isRequired,
    setting: _react2.PropTypes.object.isRequired,
    showModalChangePassword: _react2.PropTypes.func.isRequired,
    showModalConfirmMail: _react2.PropTypes.func.isRequired,
    showModalConfirmOldMail: _react2.PropTypes.func.isRequired,
    showModalConfirmPhone: _react2.PropTypes.func.isRequired,
    showModalConfirmChangePhone: _react2.PropTypes.func.isRequired,
    user: _react2.PropTypes.object,
    pushState: _react2.PropTypes.func.isRequired,
    currency: _react2.PropTypes.object.isRequired
}, _class2.defaultProps = {
    user: {}
}, _temp)) || _class) || _class));

exports.default = Profile;

function _inspect(input, depth) {
    var maxDepth = 4;
    var maxKeys = 15;

    if (depth === undefined) {
        depth = 0;
    }

    depth += 1;

    if (input === null) {
        return 'null';
    } else if (input === undefined) {
        return 'void';
    } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
        return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
    } else if (Array.isArray(input)) {
        if (input.length > 0) {
            if (depth > maxDepth) return '[...]';

            var first = _inspect(input[0], depth);

            if (input.every(function (item) {
                return _inspect(item, depth) === first;
            })) {
                return first.trim() + '[]';
            } else {
                return '[' + input.slice(0, maxKeys).map(function (item) {
                    return _inspect(item, depth);
                }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
            }
        } else {
            return 'Array';
        }
    } else {
        var keys = (0, _keys2.default)(input);

        if (!keys.length) {
            if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
                return input.constructor.name;
            } else {
                return 'Object';
            }
        }

        if (depth > maxDepth) return '{...}';
        var indent = '  '.repeat(depth - 1);
        var entries = keys.slice(0, maxKeys).map(function (key) {
            return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
        }).join('\n  ' + indent);

        if (keys.length >= maxKeys) {
            entries += '\n  ' + indent + '...';
        }

        if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
            return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
        } else {
            return '{\n  ' + indent + entries + '\n' + indent + '}';
        }
    }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Personal/Profile/Profile.jsx
// module id = 1834
// module chunks = 0